var _path, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchemaTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.67 3.5H6.33C5.71205 3.5 5.1194 3.74548 4.68244 4.18244C4.24548 4.6194 4 5.21205 4 5.83V18.17C4 18.788 4.24548 19.3806 4.68244 19.8176C5.1194 20.2545 5.71205 20.5 6.33 20.5H17.67C18.288 20.5 18.8806 20.2545 19.3176 19.8176C19.7545 19.3806 20 18.788 20 18.17V5.83C20 5.21205 19.7545 4.6194 19.3176 4.18244C18.8806 3.74548 18.288 3.5 17.67 3.5ZM19 18.17C19 18.5227 18.8599 18.861 18.6105 19.1105C18.361 19.3599 18.0227 19.5 17.67 19.5H6.33C5.97726 19.5 5.63897 19.3599 5.38955 19.1105C5.14012 18.861 5 18.5227 5 18.17V5.83C4.99867 5.65497 5.03216 5.48142 5.09853 5.31946C5.1649 5.1575 5.26281 5.01035 5.38658 4.88658C5.51035 4.76281 5.6575 4.6649 5.81946 4.59853C5.98142 4.53216 6.15497 4.49867 6.33 4.5H17.67C17.845 4.49867 18.0186 4.53216 18.1805 4.59853C18.3425 4.6649 18.4897 4.76281 18.6134 4.88658C18.7372 5.01035 18.8351 5.1575 18.9015 5.31946C18.9678 5.48142 19.0013 5.65497 19 5.83V18.17Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 14,
    height: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 12,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 1,
    height: 12,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 14,
    height: 1,
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 14,
    height: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchemaTable);
export default __webpack_public_path__ + "static/media/SchemaTable.6145fe67f0ac428672aec64c6fafbd2f.svg";
export { ForwardRef as ReactComponent };